import PeCustomerNote from '../../components/PeCustomerNotes';
import PeSingleChoice from "../../components/PeSingleChoice";
import PePersonalise from '../../components/PePersonalise';
import PeSelectBox from '../../components/PeSelectBox';
import PeTextArea from '../../components/PeTextArea';
// import PePDFContent from '../../components/pdf/PePDFContent';

const option = {
    yes_no: [{
        label: "Yes",
        value: "yes"
    }, {
        label: "No",
        value: "no"
    }],
    prepared_by: [
        {
            label: 'Paul Szuster',
            value: 'Paul Szuster',
        },
        // {
        //     label: 'Michael Golden',
        //     value: 'Michael',
        // },
        {
            label: 'Matthew Wright',
            value: 'Matthew Wright',
        },
    ],
    system_owner_entity_type: [
        {
            label: 'Individual',
            value: 'individual',
        },
        {
            label: 'Corporate Body',
            value: 'corporate_body',
        },
        {
            label: 'Government Body',
            value: 'government_body',
        },
        {
            label: 'Trustee',
            value: 'trustee',
        },
    ],
}

export const addNotesOption = [
    {
        value: ``,
        label: 'Select Notes',
    },
    {
        value: `Price is inclusive of delivery STC\nsubsidy provided as an upfront discount. Full plumber and electrician business details, ABN, trading name and Certificates must be provided within 14 calendar days / 10 business days. This is a strict timeline and if you fail to meet it you must pay the full amount and then we will pay you the subsidy at the time you make the paperwork available. There are no exceptions fo this 14 calendar day agreement. Tanks is 600mm diameter then 300mm gap to the right and 900mm long (looks like a small air con) heat pump is adjacent to the right. Other installation options available please discuss`,
        label: 'Delivery only Sanden',
    },
    {
        value: `Appreciate the update, shame to hear you are going with someone else after the work we did. Any feedback so we can improve our service? Price / speed of reply?\n\nWith your chosen Sanden supplier, do ensure they are providing you with the approved Sanden quick connection kit. This kit includes everything to be fully compliant with Sanden's installation e.g. ECV (Cold Expansion Valve), insulation gloves on the PTR, insulation gloves on the elbows, elbows with easily accessible filters).\n\nAll of our quotes include the Sanden Quick Connection Kit.\n\nAny honest feedback would be great as I thought you were very keen to get things going and I thought we were responsive to your requests.\n\nIf you get mucked around at all (e.g. poor customer service, supply problems, etc.) by your chosen supplier, we'd still be very pleased to assist as we've had many happy clients in the past (now 200+ 5 star reviews)`,
        label: 'Mucked Around Sanden(Quick Comments)',
    },
    {
        value: 'Run New RCBO Circuit for Sanden Heat Pump',
        label: 'New Circuit For Sanden Heat Pump(Electrical Notes)',
    },
    {
        value: `STC subsidy provided as an upfront discount. Full plumber and electrician business details, ABN, trading name and Certificates must be provided within 14 calendar days / 10 business days. This is a strict timeline and if you fail to meet it you must pay the full amount and then we will pay you the subsidy at the time you make the paperwork available. There are no exceptions for this 14 calendar day agreement. Site Delivery included`,
        label: 'No Plumbing Installation (Sanden - included site delivery)',
    },
    {
        value: `STC subsidy provided as an upfront discount. Full plumber and electrician business details, ABN, trading name and Certificates must be provided within 14 calendar days / 10 business days. This is a strict timeline and if you fail to meet it you must pay the full amount and then we will pay you the subsidy at the time you make the paperwork available. There are no exceptions fo this 14 calendar day agreement. Tanks is 600mm diameter then 300mm gap to the right and 900mm long (looks like a small air con) heat pump is adjacent to the right. Other installation options available please discuss.`,
        label: 'No Plumbing Installation (Sanden)',
    },
    {
        value: `Please send 2-3 photos from 2-3 metres back showing installation location / existing tank.\nPlease send switchboard photo to confirm switchboard.\nStandard installation is the tank replacing an existing electric gas or solar unit in the same location or for new build / reno where hot and cold water connections are presented 600mm diameter tank to the left, 300mm gap then 900mm long heat pump to right (looks like a small air conditioner).\nSite delivery is included. Someone must be on site to accept delivery otherwise additional charges may apply.`,
        label:
            'Plumbing Installation - Electrical Installation (Sanden - include site delivery)',
    },
    {
        value: `Please send 2-3 photos from 2-3 metres back showing installation location / existing tank.\nPlease send switchboard photo to confirm switchboard.\nStandard installation is the tank replacing an existing electric gas or solar unit in the same location or for new build / reno where hot and cold water connections are presented 600mm diameter tank to the left, 300mm gap then 900mm long heat pump to right (looks like a small air conditioner).`,
        label: 'Plumbing Installation - Electrical Installation (Sanden)',
    },
    {
        value: `Plumbing installation using our experienced team.\nElectrical commissioning by your team (with full phone support - please get them to call us to confirm installation howto).\nPlease send 2-3 photos from 2-3 metres back showing installation location / existing tank.\nPlease send switchboard photo to confirm switchboard.\nStandard installation is the tank replacing an existing electric gas or solar unit in the same location or for new build / reno where hot and cold water connections are presented 600mm diameter tank to the left, 300mm gap then 900mm long heat pump to right (looks like a small air conditioner).\nSite delivery is included.\nSomeone must be on site to accept delivery otherwise additional charges may apply.`,
        label: 'Plumbing installation using our experienced team (Sanden)',
    },
    {
        value: `Plumbing installation using our experienced team.\nElectrical commissioning by your team (with full phone support - please get them to call us to confirm installation howto).\nPlease send 2-3 photos from 2-3 metres back showing installation location / existing tank.\nPlease send switchboard photo to confirm switchboard.\nStandard installation is the tank replacing an existing electric gas or solar unit in the same location or for new build / reno where hot and cold water connections are presented 600mm diameter tank to the left, 300mm gap then 900mm long heat pump to right (looks like a small air conditioner).\nSite delivery is included.\nSomeone must be on site to accept delivery otherwise additional charges may apply.`,
        label:
            'Plumbing installation using our experienced team(Sanden - Included Site Delivery)',
    },
    {
        value: `Utilise existing RCD protected power circuit.\nEnsure to not utilise a kitchen circuit.\nTake post Sanden install photos from different angles.`,
        label: 'Sanden Electrical Recommended(Electrical Notes)',
    },
    {
        value: `Measure water pressure once arrived at site before job completion, take photo.\nIf above 500 kPa advise Pure Electric.\nMeasure water pressure at NRI PRV at completion, ensure 500kPa (if possible), take photo.\nEnsure PTR line is lagged a minimum 500mm from the PTR valve.\nAttach the drain elbow to the drain opening located on the bottom of the heat pump unit.\nThe drain elbow is included in the heat pump box.\nTake photos of the job post install.`,
        label: 'Sanden Plumbing Suggested(Plumbing Notes)',
    },
    {
        value: `- Quote is subject to photos. Assumes standard installation and assumes paved area for heat pump and existing 600x600 slab in position.\n- If slab 600x600 is requested +$40inc and if pavers requested for HP +$40inc.\n- Quote fully inclusive supply, delivery and plumbing installation using our experienced team. Why Sanden?\n- Sanden International a 75+ year business established 1943, Operating in Australia 42 years since 1978.\n- Experts in Heat Pumps.\n- Hot Water systems, Refrigeration, Heat Pump Systems for Electric Vehicles.\n- Confidence In Your Warranty backed by a company that has A$3.2Bn in Annual Revenue with A$3.4Bn in Assets.\n- Sanden Worldwide Operations with expertise in Australia, Japan, Europe, U.S, China, India.\n- The first Heat Pump Water Heater in Australia to use environmentally friendly CO2 refrigerant offering ultra high efficiency, low-temperature performance.`,
        label: 'Sanden Quote + Why Sanden',
    },
    {
        value: `Quote fully inclusive Sanden Eco Heat Pump HWS and Plumbing Installation by our experienced team.\nElectrical using your electrical team.\nAssumes standard installation with hot and cold connections presented.\nIndustry leading warranty - 6 years parts and labour for Sanden Eco Heat Pump, 10 yrs + 5 yrs pro rata for the Stainless Steel tank.\nGreat care is taken to the installation from start to finish.\nInstallation fully inclusive of quick connection kit with insulation gloves on the elbows and valves, no insulation shortcuts!\nQuote subject to photos.`,
        label:
            'Sanden S & P Install (NO E) - SS Tank - Standard Install - Subject to Photos',
    },
    {
        value: `Pure Electric Sanden Supply with the STC subsidy provided as an upfront discount.\nFull plumber and electrician business details, ABN, trading name and Certificates must be provided within 14 calendar days / 10 business days and uploaded using our secure URL link. This is a strict timeline and if not met, the STC subsidy value is immediately payable.\nSite Delivery Included.`,
        label: 'Sanden Supply Only. STCs UpFront. Site Delivery Included.',
    },
    {
        value: `Quote fully inclusive Sanden Eco Heat Pump Supply, Sanden Quickie Kit, Plumbing Installation by our experienced local team.\nQuote is subject to photos.\nElectrical by your team. Industry leading warranty - 6 years parts and labour for Sanden Eco Heat Pump, 15 yrs parts and labour Stainless Steel tank warranty (10 yrs + 5 yrs pro rata).\nFully inclusive of Sanden official plumbing quick connection kit which includes the elbows, insulator gloves for the elbows and valves so the system is the most efficient possible (no shortcuts on the insulation!)\nGreat care is taken to the installation from start to finish.\nAssumes standard installation with tank in same position, ground level. Relocation additional, subject to photos.\nAssumes 1x hot tempered and 1x cold tempered. If additional 1x hot untempered +$80inc to the quote.\nLimited time - Free Methven Kiri Satinjet Low Flow Showerhead (<5L/min) valued at $146 delivered for new Sanden Eco heat pump clients for the ultimate most efficient hot water solution!`,
        label: 'Sanden Supply and Plumbing Install - Free Methven',
    },
    {
        value: `Quote fully inclusive Sanden Eco Heat Pump Supply, Sanden Quickie Kit, Plumbing Installation and Electrical commissioning by our experienced local team.\nQuote is subject to photos.\nIndustry leading warranty - 6 years parts and labour for Sanden Eco Heat Pump, 10 years + 5 years pro rata parts and labour Stainless Steel tank warranty (15 years)\nFully inclusive of Sanden official plumbing quick connection kit which includes the elbows, insulator gloves for the elbows and valves so the system is the most efficient possible (no shortcuts on the insulation!)\nGreat care is taken to the installation from start to finish.\nAssumes nearby electrical within 2m of the heat pump.\nAssumes standard installation with tank in same position, ground level. Relocation additional, subject to photos.\nIf Power Circuit is not RCD protected +$80inc to upgrade to RCBO.\nAssumes 1x hot tempered and 1x cold tempered. If additional 1x hot untempered +$80inc to the quote.\nLimited time - Free Methven Kiri Satinjet Low Flow Showerhead (<5L/min) valued at $146 delivered for new Sanden Eco heat pump clients for the ultimate most efficient hot water solution!`,
        label:
            'Sanden Supply, Quickie Kit, Plumbing and Electrical - SS - Standard - SUBJECT TO PHOTOS - Free Methven',
    },
    {
        value: `Quote fully inclusive Sanden Eco Heat Pump Supply, Sanden Quickie Kit, Plumbing Installation and Electrical commissioning by our experienced local team.\nQuote is subject to photos.\nIndustry leading warranty - 6 years parts and labour for Sanden Eco Heat Pump, 10 years parts and labour VE tank warranty.\nFully inclusive of Sanden official plumbing quick connection kit which includes the elbows, insulator gloves for the elbows and valves so the system is the most efficient possible (no shortcuts on the insulation!)\nGreat care is taken to the installation from start to finish.\nAssumes nearby electrical within 2m of the heat pump.\nAssumes standard installation with tank in same position, ground level. Relocation additional, subject to photos.\nIf Power Circuit is not RCD protected +$80inc to upgrade to RCBO.\nAssumes 1x hot tempered and 1x cold tempered. If additional 1x hot untempered +$80inc to the quote.\nLimited time - Free Methven Kiri Satinjet Low Flow Showerhead (<5L/min) valued at $146 delivered for new Sanden Eco heat pump clients for the ultimate most efficient hot water solution!`,
        label:
            'Sanden Supply, Quickie Kit, Plumbing and Electrical - VE - Standard - SUBJECT TO PHOTOS - Free Methven',
    },
    {
        value: `Thank you for your recent Sanden Eco Plus purchase from Pure Electric. I have just sent out your Sanden maintenance tips email to help keep your Sanden in the best working order.`,
        label:
            'Thank you for your recent Sanden Eco Plus purchase from Pure Electric(Quick Comments)',
    },
    {
        value: `As we have provided STCs as an upfront discount on this quote, our STC Sanden form is required to be filled in 14 calendar days after collection, here is the link -> https://forms.gle/kCxzQ1Ks4n2W2Qtz9If the form isn't completed with 14 calendar days, we will issue the STCs as the balance of payment which will be immediately due. Then once the paperwork has been prepared, we will process the STCs at latest market rate.`,
        label:
            'The STC Sanden form is required to be filled in 14 calendar days after collection(Quick Comments)',
    },
];

export const where_hear_us_options = [
    {
        value: ``,
        label: 'Select Here',
    },
    {
        value: `Google_Search`,
        label: 'Google Search',
    },
    {
        value: `ATA_ReNew`,
        label: 'ATA ReNew',
    },
    {
        value: `Sanden_Web_Site`,
        label: 'Sanden Web Site',
    },
    {
        value: `PE_Sanden_Quote_Form`,
        label: 'PE Sanden Quote Form',
    },
    {
        value: `PE_Daikin_Quote_Form`,
        label: 'PE Daikin Quote Form',
    },
    {
        value: `ATA_Sanctuary`,
        label: 'ATA Sanctuary Magazine',
    },
    {
        value: `EarthGarden`,
        label: 'Earth & Garden',
    },
    {
        value: `ABC_Organic_Gardener`,
        label: 'ABC Organic Gardener Magazine',
    },
    {
        value: `Solargain`,
        label: 'Solargain',
    },
    {
        value: `Home_Show`,
        label: 'Home Show',
    },
    {
        value: `OneStepOffTheGrid`,
        label: 'One Step Off The Grid Website',
    },
    {
        value: `FBMyEffElecHome`,
        label: 'FB My Efficient Electric Home',
    },
    {
        value: `Trade Show`,
        label: 'Trade Show',
    },
    {
        value: `Cold Call`,
        label: 'Cold Call',
    },
    {
        value: `Web Site`,
        label: 'Web Site',
    },
    {
        value: `Existing Customer`,
        label: 'Existing Customer',
    },
    {
        value: `Self Generated`,
        label: 'Self Generated',
    },
    {
        value: `Employee`,
        label: 'Employee',
    },
    {
        value: `Partner`,
        label: 'Partner',
    },
    {
        value: `Public Relations`,
        label: 'Public Relations',
    },
    {
        value: `Direct Mail`,
        label: 'Direct Mail',
    },
    {
        value: `Conference`,
        label: 'Conference',
    },
    {
        value: `Word of mouth`,
        label: 'Word of mouth',
    },
    {
        value: `Email`,
        label: 'Email',
    },
    {
        value: `Campaign`,
        label: 'Campaign',
    },
    {
        value: `Other`,
        label: 'Other',
    },
];

export const quoteSummaryField = [
//     {
//     name: "quote_summary",
//     dependOn: "product_choice",
//     component: PeSummary,
//     props: {
//         label: "Quote Summary",
//         required: true,
//     }
// }, {
//     name: "quote_summary_moreinfo",
//     dependOn: "product_choice",
//     component: PeMoreInfo,
//     props: {
//         type: "info",
//         label: "Want more information on the Sanden? Check out our resources page." +
//             "\nPricing is subject to photos and subject to PureElectric's terms and conditions." +
//             "\nHave more questions on the Sanden? Check out our faq page!" +
//             "\nPricing assumes installation occurs within 50km of nearest PureElectric base." +
//             "\nFree Methven Kiri Satinjet Low Flow Showerhead for all new Sanden clients",
//     },
// }, 
{
    name: 'note_select',
    dependOn: "product_choice",
    component: PeSingleChoice,
    props: {
        label: 'Add notes about my site, my plans?',
        toolTip: "Add notes about my site, my plans?",
        required: true,
        options: option.yes_no,
        sm: 2,
    },
},
{
    name: 'customer_note',
    dependOn: "{\"product_choice\": \"\", \"note_select\":\"yes\"}",
    dependOnValue: 'yes',
    component: PeCustomerNote,
    props: {
        label: 'Customer Notes',
    }
},
{
    name: 'personal_info',
    dependOn: "{\"product_choice\": \"\", \"note_select\":\"\"}",
    component: PePersonalise,
    props: {
        label: 'Personalise Your Quotes',
        required: true,
    },
},
// {
//     name: 'info_pack',
//     dependOn: 'your_email',
//     component: PeSingleChoice,
//     props: {
//         label: 'Please send me our lastest info pack (includes lastest brochure, Sanden information, video)?',
//         required: true,
//         options: option.yes_no,
//         sm: 2,
//     },
// },
// {
//     name: 'scope_pdf',
//     dependOn: 'info_pack',
//     component: PeSingleChoice,
//     props: {
//         label: 'Send Electrical Scope PDF?',
//         options: option.yes_no,
//         sm: 2,
//     },
// },
// {
//     name: 'system_owner_entity_type',
//     dependOn: 'scope_pdf',
//     dependOnValue: 'yes',
//     component: PeSingleChoice,
//     props: {
//         label: 'System Owner Entity Type?',
//         options: option.system_owner_entity_type,
//         sm: 3,
//     },
// },
// {
//     name: 'prepared_by',
//     dependOn: 'info_pack',
//     component: PeSingleChoice,
//     props: {
//         label: 'Pure Electric Sales Consultant:',
//         required: true,
//         options: option.prepared_by,
//         isAuth: true,
//     },
// },
{
    name: 'hear_about',
    dependOn: "{\"product_choice\": \"\", \"your_email\":\"\", \"note_select\":\"\"}",
    component: PeSelectBox,
    props: {
        label: 'Where did you hear about us?',
        required: true,
        options: undefined,
        sm: 4,
        source: 'leadSource',
    },
},
{
    name: 'send_sms',
    component: PeSingleChoice,
    dependOn: "{\"product_choice\": \"\", \"hear_about\":\"\"}",
    props: {
        label: 'Quote via SMS?',
        options: option.yes_no,
        required: true,
        sm: 2,
    },
},
{
    name: 'sms_template',
    dependOn: 'send_sms',
    dependOnValue: 'yes',
    props: {
        required: true,
        isAuth: true,
    },
    component: PeTextArea
},
// {
//     name: "quote_pdf",
//     dependOn: "hear_about",
//     component: PePDFContent,
// }, 
]
